export default __webpack_public_path__ + "static/media/uploader-trivia-4.e0d93f9c.png";